var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H8a4 4 0 0 0-4 4v7h4v-6a1 1 0 0 1 1.005-1H16Z",
    fill: "#cfcfd9",
    className: "fill-cfcfd9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.45 24 46 3l10.5 21H13.45z",
    fill: "#1f8623",
    className: "fill-0468ad"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.45 24 46 3a14.511 14.511 0 0 1-12.979 21Z",
    fill: "#12ac2f",
    className: "fill-027de5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23h54v38H8.111A4.111 4.111 0 0 1 4 56.889V23Z",
    fill: "#d9dae2",
    className: "fill-d9dae2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61h38V23a38 38 0 0 1-38 38Z",
    fill: "#cfcfd9",
    className: "fill-cfcfd9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 27h46v30H9.14A1.14 1.14 0 0 1 8 55.86V27Z",
    fill: "#d9dae2",
    className: "fill-d9dae2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 27h42a30 30 0 0 1-30 30H8V27Z",
    fill: "#e5e6eb",
    className: "fill-e5e6eb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h16v8H44z",
    fill: "#cfcfd9",
    className: "fill-cfcfd9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h16a8 8 0 0 1-8 8h-8v-8Z",
    fill: "#e5e6eb",
    className: "fill-e5e6eb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41h2v2h-2z",
    fill: "#444444",
    className: "fill-444444"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8 37V27h10L8 37z",
    fill: "#cfcfd9",
    className: "fill-cfcfd9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8 37V27h10L8 37z",
    fill: "#ffffff",
    className: "fill-ffffff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h-1V23a1 1 0 0 0-1-1H9v-4h7a1.006 1.006 0 0 0 .555-.168l6-4A1 1 0 0 0 22 12H8a5 5 0 0 0-5 5v39.889A5.116 5.116 0 0 0 8.111 62H58a1 1 0 0 0 1-1V47h1a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1ZM5 17a3 3 0 0 1 3-3h10.7l-3 2H9.005A2.006 2.006 0 0 0 7 18v4H5Zm52 43H8.111A3.115 3.115 0 0 1 5 56.889V24h52v13h-2V27a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v28.859A2.143 2.143 0 0 0 9.141 58H54a1 1 0 0 0 1-1V47h2ZM44 47h9v9H9.141A.141.141 0 0 1 9 55.859V28h44v9h-9a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1Zm15-2H45v-6h14Z",
    fill: "#653dae",
    className: "fill-000000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41h2v2h-2z",
    fill: "#653dae",
    className: "fill-000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.cd76a6442dce1f1dc30a78f8e07bad81.svg";
export { ForwardRef as ReactComponent };